export default __webpack_public_path__ + "static/media/LifeForce LOGO2022.1c283195.jpeg";